import React, { useContext } from 'react';
import { openStoreLocatorSidebar } from '../../StoreLocator/storeLocatorSidebarState';
import { ProductContext } from '../../../ProductContext';
import { StoreLocatorType } from '../../StoreLocator/storeLocatorTypes';

const StoreLocatorAction = ({ storeLocatorType }: { storeLocatorType: StoreLocatorType }) => {
  const { sidebarPdpData } = useContext(ProductContext);

  const handleLocatorSidebarOpen = () => {
    openStoreLocatorSidebar({ feature: storeLocatorType, pdpProps: sidebarPdpData || undefined, page: 'pdp' });
  };

  return (
    <>
      <span role="button" className="body-small semibold underline" onClick={handleLocatorSidebarOpen}>
        Search by zip
      </span>{' '}
      to check availability
    </>
  );
};

export default StoreLocatorAction;
